import axios from 'axios'
import VueCookie from 'vue-cookie'

const authInterceptor = (config) => {
  /* a request that sets its own Authorization header wins. Interceptors run
     as microtasks, after the caller's synchronous code — logout deletes the
     token cookie in that window, so it must pin the header itself or the
     request goes out unauthenticated */
  if (config.headers && config.headers.Authorization) return config
  const token = VueCookie.get(process.env.VUE_APP_TOKEN)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  } else {
    delete config.headers.Authorization
  }
  return config
}
const api = axios.create({
  baseURL: process.env.VUE_APP_URL
})
api.interceptors.request.use(authInterceptor)

const checklistApi = axios.create({
  baseURL: process.env.VUE_APP_CHECKLIST_URL,
  headers: {
    common: {
      'X-AccessToken': VueCookie.get(process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN),
      'x-auth-token': process.env.VUE_APP_CHECKLIST_AUTH_TOKEN ?? ''
    }
  }
})

const hostAppApi = axios.create({
  responseType: 'json'
})
hostAppApi.interceptors.request.use(authInterceptor)

// eslint-disable-next-line
const documentUrl = process.env.VUE_APP_DOCUMENT_URL
// Attachments replaced in this tab (update / image editor): _id -> new version.
const editedAttachments = {}
const markAttachmentEdited = (...ids) => ids.filter(Boolean).forEach(id => { editedAttachments[id] = Date.now() })
// Version for an attachment's file URL, so the browser and Cloudflare may cache it until the attachment changes.
// eslint-disable-next-line camelcase
const attachmentVersion = ({ _id, modified_at }) => encodeURIComponent(editedAttachments[_id] || modified_at || Date.now())
// eslint-disable-next-line
export { api, checklistApi, documentUrl, hostAppApi, attachmentVersion, markAttachmentEdited }
